'use client';

import { useEffect, useState } from 'react';

import { uiConfig } from '@web/constants';

export function useIsMobile(breakpoint: number = uiConfig.mobileBreakpoint) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < breakpoint);

    check();

    window.addEventListener('resize', check);

    return () => window.removeEventListener('resize', check);
  }, [breakpoint]);

  return isMobile;
}
